import { Component } from '@angular/core';

@Component({
    selector: 'je-wait',
    templateUrl: './wait.component.html',
    standalone: true,
})
export class JeWaitComponent {}
